import React from "react";
import { IoAddOutline, IoTrashOutline, IoLinkOutline } from "react-icons/io5";

/**
 * Lista editable de enlaces externos (OneDrive, SharePoint, etc.) como
 * alternativa/complemento a subir un documento. `value` es un array de
 * strings (URLs); `onChange` recibe el array actualizado.
 */
export default function EnlacesField({
  label = "Enlaces (OneDrive, SharePoint…)",
  value,
  onChange,
  buttonClassName,
  dangerButtonClassName,
  inputClassName,
  style,
}) {
  const enlaces = value || [];

  const handleAdd = () => onChange([...enlaces, ""]);
  const handleRemove = (i) => onChange(enlaces.filter((_, idx) => idx !== i));
  const handleChange = (i, v) => {
    const next = [...enlaces];
    next[i] = v;
    onChange(next);
  };

  const defaultBtnStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "6px 12px",
    borderRadius: 6,
    border: "1px solid #ccc",
    background: "#f5f5f5",
    cursor: "pointer",
  };

  return (
    <div style={{ marginTop: 10, ...style }}>
      <label style={{ display: "block", marginBottom: 4, fontWeight: 600 }}>{label}</label>
      {enlaces.map((url, i) => (
        <div key={i} style={{ display: "flex", gap: 8, marginTop: 6 }}>
          <input
            type="url"
            placeholder="https://..."
            value={url}
            onChange={(e) => handleChange(i, e.target.value)}
            className={inputClassName}
            style={{ flex: 1 }}
          />
          <button
            type="button"
            className={dangerButtonClassName}
            style={dangerButtonClassName ? undefined : { ...defaultBtnStyle, background: "#fdecea", borderColor: "#e57373" }}
            onClick={() => handleRemove(i)}
            title="Eliminar enlace"
          >
            <IoTrashOutline />
          </button>
        </div>
      ))}
      <button
        type="button"
        className={buttonClassName}
        style={buttonClassName ? { marginTop: 8 } : { ...defaultBtnStyle, marginTop: 8 }}
        onClick={handleAdd}
      >
        <IoAddOutline /> Añadir enlace
      </button>
      {enlaces.length === 0 && (
        <p style={{ margin: "4px 0 0", fontSize: 12, color: "#888", display: "flex", alignItems: "center", gap: 4 }}>
          <IoLinkOutline /> Sin enlaces añadidos
        </p>
      )}
    </div>
  );
}
